import React ,{useEffect, useState} from 'react'
import Cookies from 'universal-cookie';
import { captureException } from '@sentry/browser';
import { DataGrid ,GridToolbarQuickFilter} from '@mui/x-data-grid';
import Moment, { now } from 'moment'
import InfoIcon from '@mui/icons-material/Info';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import './Audits.css'
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const cookies = new Cookies();

export default function Audits(){

  const duration_map = {
    "Today" : 1,
    "This week" : 7,
    "This month" : 31,
    "All time" : 1000
  }

  const duration_options = {
    options: ["Today","This week","This month","All time"],
    getOptionLabel: (option) => option,
  };
  const[open_modal,set_open_modal]=useState(false);
  const [audits,set_audits] = useState([])
  const [data,set_data] = useState()
  const[duration,set_duration] = useState("Today")
  
  const [filterModel, setFilterModel] = useState({
    items: [
      {
        columnField: 'code_owner',
        operatorValue: 'contains',
        value: ""
      },
    ],
  });
  const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 500,
      bgcolor: 'background.paper',
      border: '2px solid #000',
      boxShadow: 24,
      p: 4,
    };

    useEffect( () => {
        var options = {
          'method': 'POST',
          'headers': {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "code": cookies.get("code"),
          "days" : duration_map[duration]
        })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_audits/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
        data.forEach(element => {
            element["time"] = Moment(element["time"]).format('LLL')
            element["data"]=JSON.parse(element["data"])
        });
        set_audits(data)
      }
      catch (error){
        const event_id = captureException(error);
        console.log('error logged', { event_id });
      }

     });

     
    },[duration])
    const handleClose = () => set_open_modal(false);

    const columns = [
        { field: 'action', headerName: 'Action', width: 350 },
        { field: 'user_name', headerName: 'User Name', width: 350 } ,
        { field: 'time', headerName: 'Date', width: 350 } ,
        {
            field: "data",
            headerName: "Details",
            sortable: false,
            width: 200,
            renderCell: (params) => {
              return (
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer", zIndex:10000 , position: "relative"}}
                >
                  <InfoIcon index={params.row.id} />
                </div>
              );
            }
          }
      ];

      function QuickSearchToolbar() {
        return (
            <GridToolbarQuickFilter />
        );
      }
      function update_action_filter(cellData){
        if(filterModel.items[0]?.value==cellData.row.action){
          setFilterModel({
            items: [
              {
                columnField: 'action',
                operatorValue: 'contains',
                value: ""
              },
            ],
          })
        }
        else{
          setFilterModel({
            items: [
              {
                columnField: 'action',
                operatorValue: 'contains',
                value: cellData.row.action
              },
            ],
          })
        }
      }
      function update_user_name_filter(cellData){
        if(filterModel.items[0]?.value==cellData.row.user_name){
          setFilterModel({
            items: [
              {
                columnField: 'user_name',
                operatorValue: 'contains',
                value: ""
              },
            ],
          })
        }
        else{
          setFilterModel({
            items: [
              {
                columnField: 'user_name',
                operatorValue: 'contains',
                value: cellData.row.user_name
              },
            ],
          })
        }
      }
      const PrettyPrintJson = ({data}) => (<a><pre>{JSON.stringify(data, null, 2) }</pre></a>);
    return (
        <div className="split right" >
          <a className="audit_header">
        <a className="audits_title">
          Audits
          
        </a>
        <a className="duration_autocomplete">
          <Autocomplete
            {...duration_options}
            autoSelect
            size="small"
            noOptionsText="loading more options..."
            defaultValue="Today"
            sx={{ "width": "200px" }}
            onChange={(event, value) => set_duration(value)}
            renderInput={(params) => (
            <TextField {...params} />
            )}
          />

        </a>
        </a>
        <div style={{ height: '90%', width: '100%' , "background-color": "white"}} className="audits_table">
          
          {audits && <DataGrid
            rows={audits}
            columns={columns}
            filterModel={filterModel}
            onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
            pageSize={30}
            rowsPerPageOptions={[30]}
            sx={{
              boxShadow: 2,
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            components={{ Toolbar: QuickSearchToolbar }}
            disableSelectionOnClick={true}
            onCellClick={(cellData) => {
                if(cellData.field=="data"){
                  set_data(cellData.row.data)
                  set_open_modal(true)
                }
                else if(cellData.field=="action"){
                  update_action_filter(cellData)
                }
                else if(cellData.field=="user_name"){
                  update_user_name_filter(cellData)
                }
            }}
          />
          }
        </div>
        <Modal
        open={open_modal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{"box-sizing": "content-box"}}
      >
        <Box sx={style}>
          <Typography component={'span'} variant={'h6'} id="modal-modal-title" >
            Details
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {open_modal && <PrettyPrintJson data={data}/>  }
          </Typography>
        </Box>
      </Modal>
      </div>
    )
}